export default class TempAddLayer {
  static isliang = true;
  static openName = ""
  static playAnimation (season) {
    console.log(season, 111111);
    window.appInstance.uniCall('playAnimation', {
      animationName: 'SwitchSeason', //切换季节
      state: season
    }, res => {
      console.log(res, season, 111111);
    })
  }
  static adddianziweilan () {
    let jsonData = {
      id: 'circularArea',//图层对象id，新建时调用者自己传入的唯一标识，用于各种操作的对象识别
      name: '圆形区域轮廓',//图层名称，支持为图层自定义名称
      coordType: 0,//XY轴坐标类别，0：X经度，Y纬度；1：X米，Y米，相对世界00点
      coordTypeZ: 0,//Z轴坐标类别，0：相对3D世界0海拔；1：相对3D世界地表；2：相对3D模型表面（单位：米）
      coordZ: -70,//Z轴高度（单位：米）
      type: 'Gradient02',//区域边界样式类别Arrow01Gradient01Gradient02Gradient03Grid01Grid02Grid03Grid04Grid05Segment01Segment02Segment03
      color: '#FFFF00',//颜色（HEX颜色值）
      areaHeight: 130,//围栏高度（单位：米）
      fillArea: 'none',//区域填充样式类别Gradient01Gradient02Grid01Grid02Segment01Segment02
      center: [-0.00016449811, -0.00029737752],//圆心XY轴坐标，X：经度；Y：纬度
      radius: 140,//半径（单位：米）
      fillPosition: 'top',//区域填充的位置，top/bottom，默认top
      tag: "custominfo",//用户自定标签，用户保存用户的扩展数据
      visible: true,//添加当前图层时默认是显示还是隐藏
    };

    window.appInstance.uniCall('clearOverlayType', {
      overlayType: 'circularArea',//覆盖物类型，支持all
    },
      result => {
        console.log(result);
      }
    );
    window.appInstance.uniCall('addCircularArea', jsonData, result => {
      console.log(result);
      if (result.result === 1) {

      }
    });
  }

  //更新电子围栏颜色
  static updateCircularAreaStyle (color) {
    window.appInstance.uniCall('updateCircularAreaStyle', {
      id: "circularArea",
      type: "Gradient02",
      color: color,
      areaHeight: 130,
      fillArea: "none",
      fillPosition: "top"
    }
    )
  }
  //更新检修标牌颜色
  static updateLandmarkLayerStyle (name) {
    window.appInstance.uniCall('updateLandmarkLayerStyle', {
      id: "FaDianZhan-检修中",
      isAppend: false,
      legends: [
        {
          name: "default",
          color: "#ff0000",
          iconName: name
        }
      ]
    }
      , (res) => {
       console.log(res)
      })
  }


  //添加事件图
  static addeventlayer () {
    let jsonData = {
      "id": "FaDianZhan-告警事件",
      "name": "FaDianZhan-告警事件",
      "coordType": 0,
      "coordTypeZ": 0,
      "visible": true,
      "legends": [
        {
          "name": "default",
          "icon": "custom-告警事件",
          "type": "wave",
          "color": "#ff0000",
          "fillArea": "type01",
          "speed": 10,
          "radius": 25
        }
      ],
      "data": [
        {
          "id": 111,
          "coord": [
            "0.00037685765",
            "0.00021025711"
          ],
          "coordZ": -63.31104492188,
          "message": "",
          "type": "default"
        }
      ],
      "callbackId": "7628a2b4-eacc-b90d-eadf-7b5a98f09d82"
    }
    window.appInstance.uniCall('addEventLayer', jsonData, (res) => {
      console.log('addEventLayer', jsonData, res)
      let pickJsonData1 = {
        overlayType: "eventLayer",
        idLayer: jsonData.id,
        type: "click",
        allowMultiple: false,
        isShowDecorator: true
      }
      let pickJsonData2 = {
        overlayType: "eventLayer",
        idLayer: jsonData.id,
        type: "hover",
        allowMultiple: false,
        isShowDecorator: false
      }
      appInstance.uniCall('pickOverlay', pickJsonData1, res => {
        console.log('pickJsonData1', pickJsonData1, res)
      })
    })
  }
  //删除事件图
  static removeeventLayer () {

    window.appInstance.uniCall(
      'removeOverlay', {
      id: 'FaDianZhan-告警事件',
      overlayType: 'eventLayer',
    },
      (res) => {

      }
    )
  }

  //模型显示
  static higlightMode (item) {
    this.huifu(this.openName);
    let index = Number(0.05)
    if (this.openName == item) {

      this.openName = ""
    } else {

      this.openName = item
    }

    this.modediguo(index, item)

  }
  //模型显示递归
  static modediguo (index, itemname) {
    if (itemname != this.openName) {
      return;
    }
    let jsonData = {
      id: itemname, // 模型对象 id，新建时调用者自己传入的唯一标识，用于各种操作的对象识别
      alpha: 1, // 模型透明度，0：完全透明；1：完全不透明
      scale: 1, // 模型整体放缩倍数（单位：倍）
      maskType: 'color', // 模型遮罩样式类别，color：颜色遮罩；picture：图片遮罩；none：无遮罩
      maskAlpha: index, // 遮罩透明度，0：完全透明；1：完全不透明
      maskColor: '#990000', // 遮罩颜色（HEX 颜色值）
      maskPicture: 'Arrow02', //内置遮罩样式 Arrow01 Arrow02 Arrow03 Arrow04 Arrow05 Arrow06 Segment01 Segment02 Segment03 Segment04 Segment05 Segment06；或根据项目，在场景中预置好的图片 URL
      maskPictureScale: 1.0, // 遮罩贴图的比例系数
      maskFlowSpeed: 1.0, // 遮罩贴图的流动速度系数
      maskFlowDirection: 180, // 遮罩贴图 UV 流动方向角度， 0-360 度
      includeChildren: 'true',	// 当前样式设置是否包含子节点，此功能可以实现例如控制子节点显隐的功能
      xRay: 'off', // X 光样式（半透明效果，且不会被前方物体遮挡）开关，on：开启 X 光效果；off：关闭 X 光效果
    };
    appInstance.uniCall('setModelStyle', jsonData, (result) => {
      
      console.log(index);
      if (index == 0) {
        this.isliang = true
      }
      if (index == 0.95) {
        this.isliang = false
      }
      if (this.isliang) {
        index = index + 0.05
      } else {
        index = index - 0.05
      }
      // setTimeout(() => {

      // }, 50);
      index = parseFloat(index).toFixed(2)
      this.modediguo(Number(index), itemname)

    });
  }

  //恢复模型
  static huifu (itemname) {
    let jsonData = {
      id: itemname, // 模型对象 id，新建时调用者自己传入的唯一标识，用于各种操作的对象识别
      alpha: 1, // 模型透明度，0：完全透明；1：完全不透明
      scale: 1, // 模型整体放缩倍数（单位：倍）
      maskType: 'none', // 模型遮罩样式类别，color：颜色遮罩；picture：图片遮罩；none：无遮罩
      maskAlpha: 0, // 遮罩透明度，0：完全透明；1：完全不透明
      maskColor: '#990000', // 遮罩颜色（HEX 颜色值）
      maskPicture: 'Arrow02', //内置遮罩样式 Arrow01 Arrow02 Arrow03 Arrow04 Arrow05 Arrow06 Segment01 Segment02 Segment03 Segment04 Segment05 Segment06；或根据项目，在场景中预置好的图片 URL
      maskPictureScale: 1.0, // 遮罩贴图的比例系数
      maskFlowSpeed: 1.0, // 遮罩贴图的流动速度系数
      maskFlowDirection: 180, // 遮罩贴图 UV 流动方向角度， 0-360 度
      includeChildren: 'true',	// 当前样式设置是否包含子节点，此功能可以实现例如控制子节点显隐的功能
      xRay: 'off', // X 光样式（半透明效果，且不会被前方物体遮挡）开关，on：开启 X 光效果；off：关闭 X 光效果
    };
    appInstance.uniCall('setModelStyle', jsonData, (result) => {

    })
  }


}
